export default {
    config: {
        dark: true, // Enables dark theme globally
        brand: {
            primary: '#c49a6c', // Gold tone from your logo
            secondary: '#1a1a1a', // Dark background
            accent: '#ff9800',
        },
    },
};
